export default __webpack_public_path__ + "9abcecb55e3ca90deb796a9c8b7c28b1.png";